import { useContext, useState } from 'react';

import { AppContext, EMPTY_STRING } from 'commons-ui';

import useService from '../../utils/useService';
import { ITournamentApprovalTournamentData } from '../../utils/constants';

export const useList = () => {
	const emptyCsvObject = { oldCsv: '', newCsv: '' };
	const [showLoader, setShowLoader] = useState(false);
	const [confirmation, setConfirmation] = useState<boolean>(false);
	const [approvalConfirmation, setApprovalConfirmation] = useState<boolean>(false);
	const [docId, setDocId] = useState<string>('');
	const [csvForApprovaldocId, setcsvForApprovaldocId] = useState<string>('');
	const [rollbackData, setRollbackData] = useState<string>('');
	const [preProdCsvDiffValue, setPreProdCsvDiffValue] = useState(emptyCsvObject);
	const { app, showAlert } = useContext(AppContext);
	const { rollbackTournamentFile, requestCsvDiff, approveTournamentCsvService } = useService();

	const rollbackTournamentCsv = (data: any) => {
		setShowLoader(true);
		rollbackTournamentFile({ app }, { ...data }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.success) {
					showAlert(res?.data?.error || 'Error while rolling back tournament', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Rollback is in progress, please refresh to get latest entry');
					setShowLoader(false);
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.message}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const approveTournamentCsv = (data: ITournamentApprovalTournamentData) => {
		setShowLoader(true);
		approveTournamentCsvService({ app }, { ...data }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.success) {
					showAlert(res?.data?.error || 'Error while approving tournament csv', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Csv approved');
					setShowLoader(false);
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.message}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const getCsvDiff = (data: ITournamentApprovalTournamentData) => {
		setShowLoader(true);
		requestCsvDiff(app.appName, { ...data }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while getting diff', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Csv Diff loaded');
					setShowLoader(false);
					setPreProdCsvDiffValue(res?.data?.data || emptyCsvObject);
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleRollback = (submittedData: any) => {
		setConfirmation(true);
		setDocId(submittedData.docId);
		const gameMetaData: string = `${submittedData.gameName}: ${submittedData.path}`;
		setRollbackData(gameMetaData);
	};

	const handleApproval = (submittedData: ITournamentApprovalTournamentData) => {
		setApprovalConfirmation(true);
		setcsvForApprovaldocId(submittedData.docId);
	};

	const confirmationDialogOnClose = () => {
		setConfirmation(false);
		setDocId('');
	};

	const confirmationDialogOnAgree = (submittedData: any) => {
		setConfirmation(false);
		setShowLoader(true);
		rollbackTournamentCsv(submittedData);
	};

	const approvalConfirmationDialogOnClose = () => {
		setApprovalConfirmation(false);
		setcsvForApprovaldocId(EMPTY_STRING);
	};

	const approvalConfirmationDialogOnAgree = (submittedData: ITournamentApprovalTournamentData) => {
		setApprovalConfirmation(false);
		setShowLoader(true);
		approveTournamentCsv(submittedData);
	};

	return {
		handleRollback,
		showLoader,
		confirmation,
		confirmationDialogOnClose,
		rollbackTournamentCsv,
		confirmationDialogOnAgree,
		rollbackData,
		docId,
		csvForApprovaldocId,
		preProdCsvDiffValue,
		getCsvDiff,
		handleApproval,
		approveTournamentCsv,
		approvalConfirmationDialogOnClose,
		approvalConfirmationDialogOnAgree,
		approvalConfirmation
	};
};

export default useList;
